import { CoreFormFieldCheckbox } from '../fields/CoreFormFieldCheckbox';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import {
  FormFieldController,
  FormFieldControllerRulesProps,
} from './FormFieldController';

export const ContextFormFieldCheckbox = ({
  fieldPath,
  rules,
  label,
  helperText,
  disabled,
  variant,
}: ContextFormFieldBaseProps & { variant?: 'default' | 'bordered' }) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field }) => (
        <CoreFormFieldCheckbox
          id={fieldPath}
          label={rules?.required ? `${label} *` : label}
          checked={field.value}
          onChange={field.onChange}
          helperText={helperText}
          disabled={disabled}
          variant={variant}
        />
      )}
    </FormFieldController>
  );
};
